import { motion } from 'framer-motion'
import {
  FiFolder,
  FiCheckSquare,
  FiBarChart2,
  FiLayout,
  FiMessageSquare,
  FiTarget,
  FiUsers,
  FiFileText,
  FiShuffle,
  FiClock,
  FiUserPlus,
  FiMoon,
} from 'react-icons/fi'

const features = [
  {
    id: 'projects',
    title: 'Gerenciamento de Projetos',
    description: 'Crie, organize e gerencie projetos com colaboradores e permissões personalizadas.',
    icon: FiFolder,
    color: 'text-blue-600',
  },
  {
    id: 'tasks',
    title: 'Tarefas e Subtarefas',
    description: 'Sistema completo de tarefas hierárquicas com status, responsáveis e prazos.',
    icon: FiCheckSquare,
    color: 'text-green-600',
  },
  {
    id: 'dashboard',
    title: 'Dashboard Inteligente',
    description: 'Estatísticas e métricas em tempo real para acompanhar o progresso dos projetos.',
    icon: FiBarChart2,
    color: 'text-purple-600',
  },
  {
    id: 'kanban',
    title: 'Kanban Board',
    description: 'Visualize e organize tarefas em colunas personalizáveis com drag and drop.',
    icon: FiLayout,
    color: 'text-orange-600',
  },
  {
    id: 'comments',
    title: 'Comentários e Colaboração',
    description: 'Comunicação em tempo real com editor de texto rico e menções.',
    icon: FiMessageSquare,
    color: 'text-pink-600',
  },
  {
    id: 'okrs',
    title: 'OKRs',
    description: 'Gestão de objetivos e resultados-chave para alinhar equipes e medir sucesso.',
    icon: FiTarget,
    color: 'text-red-600',
  },
  {
    id: 'teams',
    title: 'Equipes',
    description: 'Gerencie equipes, atribua membros e controle permissões de acesso.',
    icon: FiUsers,
    color: 'text-indigo-600',
  },
  {
    id: 'documents',
    title: 'Documentos',
    description: 'Centralize documentos importantes e mantenha tudo organizado.',
    icon: FiFileText,
    color: 'text-teal-600',
  },
  {
    id: 'sprints',
    title: 'Sprints',
    description: 'Metodologia ágil com planejamento e acompanhamento de sprints.',
    icon: FiShuffle,
    color: 'text-cyan-600',
  },
  {
    id: 'time',
    title: 'Time Tracking',
    description: 'Controle de tempo trabalhado em projetos e tarefas.',
    icon: FiClock,
    color: 'text-yellow-600',
  },
  {
    id: 'unlimited-users',
    title: 'Sem Limite de Usuários',
    description: 'Adicione quantos colaboradores precisar sem restrições ou limites.',
    icon: FiUserPlus,
    color: 'text-emerald-600',
  },
  {
    id: 'darkmode',
    title: 'Dark Mode',
    description: 'Interface adaptável com suporte a tema claro e escuro.',
    icon: FiMoon,
    color: 'text-slate-600',
  },
]

export const Features = () => {
  return (
    <section id="features" className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="container mx-auto max-w-7xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Funcionalidades Completas
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Tudo que você precisa para gerenciar projetos com eficiência e alcançar resultados extraordinários.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => {
            const Icon = feature.icon
            return (
              <motion.div
                key={feature.id}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="bg-white p-6 rounded-xl border border-gray-200 hover:border-primary-300 hover:shadow-lg transition-all duration-300 group"
              >
                <div className={`inline-flex p-3 rounded-lg bg-gray-50 group-hover:bg-primary-50 transition-colors mb-4 ${feature.color}`}>
                  <Icon size={24} />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  {feature.title}
                </h3>
                <p className="text-gray-600">
                  {feature.description}
                </p>
              </motion.div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

